var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({staticClass:"tag-select",attrs:{"value":_vm.value,"dense":"","outlined":"","items":_vm.items,"item-text":"label","item-value":"value"},on:{"change":_vm.valueChanged}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }